import React from 'react';
import { PlusIcon } from 'lucide-react';
interface CoffeeHeaderProps {
  onCreateClick: () => void;
}
const CoffeeHeader: React.FC<CoffeeHeaderProps> = ({
  onCreateClick
}) => {
  return <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-325">
      <div className="mb-4 md:mb-0" data-id="element-326">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-327">
          Eventi Greenback
        </h1>
        <p className="text-sm text-gray-600 font-normal mt-1" data-id="element-328">
          Partecipa agli eventi della community e guadagna punti
        </p>
      </div>
      <div className="flex space-x-3" data-id="element-329">
        <button onClick={onCreateClick} className="flex items-center justify-center py-2 px-4 bg-custom-green text-white rounded-lg hover:bg-custom-green/90 transition-colors" data-id="element-330">
          <PlusIcon size={18} className="mr-2" data-id="element-331" />
          Crea Evento
        </button>
      </div>
    </div>;
};
export default CoffeeHeader;